import { render, staticRenderFns } from "./ElementBadge.vue?vue&type=template&id=fad7ecc2&"
import script from "./ElementBadge.vue?vue&type=script&lang=js&"
export * from "./ElementBadge.vue?vue&type=script&lang=js&"
import style0 from "./ElementBadge.vue?vue&type=style&index=0&id=fad7ecc2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports